import React, { useLayoutEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { AppDispatch, RootState } from '@mse-reg/app/store';
import { Alert, AlertTitle } from '@mui/material';
import { TextContent } from '../../../ui/structural/text-content';
import { authThunks } from './auth.slice';

const mapStateToProps = ({ auth }: RootState) => ({
  isLoggedIn: auth.isLoggedIn,
  logoutUrl: auth.logoutUrl,
  idToken: auth.idToken,
});

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    async logoutAsync() {
      return await dispatch(authThunks.logoutThunk()).unwrap();
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export type Props = PropsFromRedux & { idToken: string; logoutUrl: string };

export const Logout = (props: Props) => {
  useLayoutEffect(() => {
    const loadInitialData = async () => {
      if (props.isLoggedIn) {
        const logoutUrl = await props.logoutAsync();
        if (logoutUrl) {
          window.location.href = logoutUrl.includes('/protocol')
            ? logoutUrl + '?redirect_uri=' + window.location.origin
            : logoutUrl + '?id_token_hint=' + props.idToken + '&post_logout_redirect_uri=' + window.location.origin;
        }
      }
    };

    loadInitialData();
  });

  return (
    <TextContent>
      <Alert color="success">
        <AlertTitle>Bye Bye! :(</AlertTitle>
        Hope to see you back here soon! ;)
      </Alert>
    </TextContent>
  );
};

export default connector(Logout);
